import { useMemo } from 'react';
import * as XLSX from 'xlsx';
import exportLogo from '../../assets/export-xls.png';

// Labels pour l'export
const TYPE_LABELS = {
  Automatismes: 'Automatismes',
  Problèmes: 'Résolution de problèmes',
  Lexique: 'Lexique',
  ComprehensionEcrite: "Compréhension de l'écrit",
  CompetencesLangagieres: 'Compétences langagières et linguistiques',
};

const ExportEvolution = ({ mockDataByType, testSpecifique, referenceYear, comparisonYear, niveau }) => {

  const exportData = useMemo(() => {
    const data = mockDataByType?.[testSpecifique] || [];
    return data.map((item) => ({
      ...item,
      referenceResult: item.results[referenceYear] || 0,
      comparisonResult: item.results[comparisonYear] || 0,
      difference: (item.results[referenceYear] || 0) - (item.results[comparisonYear] || 0),
    }));
  }, [mockDataByType, testSpecifique, referenceYear, comparisonYear]);

  const handleExport = () => {
    if (!exportData || exportData.length === 0) {
      console.error("Les données d'export ne sont pas prêtes !");
      return;
    }

    // Fonction pour transformer les données en feuille Excel
    const createSheet = (data, testName) => {
      const headers = [
        [testName.toUpperCase()],
        [
          "N°",
          "Savoir-Faire",
          `% Réussite ${comparisonYear}`,
          `% Réussite ${referenceYear}`,
          "Écart",
        ],
      ];
      const rows = data.map((item, index) => {
        const results = item.results;
        const values = [
          results[comparisonYear] || 0,
          results[referenceYear] || 0,
          (results[referenceYear] || 0) - (results[comparisonYear] || 0),
        ];

        return [index + 1, item.name, ...values];
      });
      return XLSX.utils.aoa_to_sheet([...headers, ...rows]);
    };

    // Générer la feuille pour le type sélectionné
    const sheetName = TYPE_LABELS[testSpecifique] || testSpecifique;
    const sheet = createSheet(exportData, sheetName);

    // Créer un classeur et y ajouter la feuille
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, sheetName.substring(0, 31)); // Max 31 chars pour nom de feuille Excel

    // Exporter le fichier Excel
    XLSX.writeFile(workbook, `Evolution_${testSpecifique}_${referenceYear}_${comparisonYear}_${niveau}.xlsx`);
  };
  
    return (
      <img
        onClick={handleExport}
        src={exportLogo}
        alt="Exporter en Excel"
        className="xl:w-10 w-8 hover:cursor-pointer"
      />
    );
  };
  
  export default ExportEvolution;